export default function() {
  return {
    sellings: [],
    selling: {},
    lists: []
  }
}
